var MediaCover = require("app/ui/covers/MediaCover"),
    get        = require("object-path").get,
    icons      = require("app/theme/icons"),
    kind       = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.covers.VideoCover.prototype */ {

    /**
     * @private
     */
    name: "app.ui.covers.VideoCover",

    /**
     * @private
     */
    kind: MediaCover,

    /**
     * @private
     */
    classes: "app-ui-covers-video-cover",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: kind.inherit(function(sup) {
        return function() {
            var i18nService   = this.app.$.i18nService,
                data          = this.data || {},
                isLivestream  = get(data, "is_livestream", false),
                $imageWrapper = this.$.imageWrapper,
                $liveBar      = this.$.liveBar,
                $playLink     = this.$.playLink;

            $imageWrapper.set("href", get(data, "links.self", null));
            $imageWrapper.setAttribute("title", i18nService.getString("app.ui.covers.VideoCover.infoLink.tooltip"));

            if (isLivestream) {
                $liveBar.set("href", get(data, "links.player", null));
                this.startLiveBar(
                    Date.parse(get(data, "datetime_livestream_start", 0)) / 1000,
                    Date.parse(get(data, "datetime_livestream_end", 0)) / 1000
                );
            }
            else {
                $liveBar.set("href", null);
                this.stopLiveBar();
            }

            this.$.playIcon.set("icon", icons["app.ui.covers.VideoCover.playIcon"]);

            $playLink.set("href", get(data, "links.player", null));
            $playLink.setAttribute("title", i18nService.getString("app.ui.covers.VideoCover.playerLink.tooltip"));

            sup.apply(this, arguments);
        };
    })

});
